import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleDprHeader = {
  namespaced: true,

  state: {
    name: "prj-search",
    prjDate: null,
  },

  mutations,
  getters,
  actions,
};

export default moduleDprHeader;
